import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { BaseTransformer } from './BaseTransformer';
var url = require('@/assets/avatar/dummy-avatar.svg');
export var UserTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(UserTransformer, _BaseTransformer);
  var _super = _createSuper(UserTransformer);
  function UserTransformer() {
    _classCallCheck(this, UserTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(UserTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      // if(!data.language || !data.timezone || !data.locale){ 
      //         try {
      //             let localeOpts = Intl.DateTimeFormat().resolvedOptions();  
      //             if(!this.data.timezone){   this.data.timezone = localeOpts.timeZone;   }

      //             if(!this.data.locale){    
      //                 let countryId = localeOpts.locale.toUpperCase(),
      //                 localeId = countryId.toLowerCase() + '_' + countryId.toLocaleUpperCase(),
      //                 languageId = localeId;
      //                 this.data.locale = localeOpts.localeId;
      //             }

      //             if(!this.data.language){    
      //               let langInput = $("select[name='language_id']");
      //           if (langInput.find("option[value='" + languageId + "']").length) {
      //               langInput.val(languageId);
      //           }

      //           $("select[name='locale_id']").val(localeId);
      //       } catch (e) {

      //       }
      // }
      if (data.licenses) {
        data.licenses = data.licenses.map(function (k) {
          k.packageAppId = k.packageAppId == "kivaprojects" ? "projects" : k.packageAppId == "kivasales" ? "sales" : k.packageAppId == "kivadesk" ? "desk" : k.packageAppId == "kivainvoice" ? "invoice" : k.packageAppId;
          return k;
        });
      }
      return {
        firstname: data.firstname,
        lastname: data.lastname,
        accountId: data.account_id,
        email: data.email,
        mobile: data.mobile,
        gender: data.gender,
        extension: data.extension,
        status: data.status,
        profile: data.profile ? data.profile.value : null,
        profileName: data.profile ? data.profile.label : null,
        role: data.role ? data.role.value : null,
        roleName: data.role ? data.role.label : null,
        photo: data.photo,
        avatar: data.photo ? process.env.VUE_APP_BASE_URL + '/' + data.photo : url,
        uxProfiles: data.ux_profiles ? parseInt(data.ux_profiles) : null,
        uxStaticProfiles: data.ux_profiles ? parseInt(data.ux_profiles) : null,
        language: data.language,
        timezone: data.timezone,
        locale: data.locale,
        birthday: data.birthday,
        dateOfBirth: data.date_of_birth,
        jobTitle: data.job_title,
        hr_employee_id: data.hr_employee_id,
        activity_status: data.activity_status,
        dateOfRecruitment: data.date_of_recruitment,
        leaveRightCalculationStartDate: data.leave_right_calculation_start_date,
        usedLeaveRights: data.used_leave_rights,
        primaryManager: data.primary_manager,
        secondaryManager: data.secondary_manager,
        employmentDuration: data.employment_duration,
        totalLeaveRight: data.total_leave_right,
        remainingLeaveRight: data.remaining_leave_right,
        capacity: data.capacity,
        defaultHourlyRate: data.default_hourly_rate,
        hourlyCost: data.hourly_cost,
        success: data.success,
        userId: data.user_id,
        value: data.user_id,
        fullName: "".concat(data.firstname, " ").concat(data.lastname),
        hourlyCostCur: data.hourly_cost__cur,
        defaultHourlyRateCur: data.default_hourly_rate__cur,
        primaryTeam: data.primary_team,
        licenses: data.licenses,
        licensesKey: data.licenses && data.licenses[0] ? data.licenses.map(function (k) {
          return k.accountLicenseId;
        }) : data.licenses,
        lastLogin: data.last_login,
        timeTrackingRequired: data.time_tracking_required
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      console.log(data);
      return {
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
        mobile: data.mobile,
        gender: data.gender,
        capacity: data.capacity,
        default_hourly_rate: parseFloat(data.defaultHourlyRate),
        hourly_cost: parseFloat(data.hourlyCost),
        default_hourly_rate__cur: data.defaultHourlyRateCur,
        hourly_cost__cur: data.hourlyCostCur,
        language: data.language,
        timezone: data.timezone,
        locale: data.locale,
        photo: data.photo,
        status: data.status,
        licenses: data.licensesKey,
        primary_team: data.primaryTeam,
        // user_profile_id: data.userId,
        profile: data.profile,
        role: data.role,
        ux_profiles: data.uxProfiles
      };
    }
  }]);
  return UserTransformer;
}(BaseTransformer);